import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import ErrorBar from '~/components/ErrorBar';
import HeaderBar from '~/components/HeaderBar';
import ProtectedRoute from '~/components/ProtectedRoute';
import Dashboard from '~/routes/Dashboard';
import Login from '~/routes/Login';
import './style.css';

// Top level router for auth gate and dashboard
function App() {
  return (
    <div id="app">
      <HeaderBar />
      <Switch>
        <Route exact path="/login" component={Login} />
        <ProtectedRoute path="/dashboard" component={Dashboard} />
        <Route exact path="/" render={() => <Redirect to="/login" />} />
        <Route component={() => <h6>404</h6>} />
      </Switch>
      <ErrorBar />
    </div>
  );
}

export default App;
